'use strict';

var AnalysisKpiRibbonAggregationFactory = function AnalysisKpiRibbonAggregationFactory(AbstractRomKpiRibbonAggregationFactory) {
  function KpiRibbonAggregation() {
    AbstractRomKpiRibbonAggregationFactory.call(this, ['rom-analysis-skinny-services-mode'], 'kpi-ribbon');
  }
  KpiRibbonAggregation.prototype = Object.create(AbstractRomKpiRibbonAggregationFactory.prototype);
  KpiRibbonAggregation.constructor = KpiRibbonAggregation;
  KpiRibbonAggregation.prototype.canAggregate = function (sourceType, targetType) {
    return this.sourceType.indexOf(sourceType) !== -1 && this.targetType === targetType;
  };
  KpiRibbonAggregation.prototype.aggregate = function (data, metricsKeys) {
    var grouped = {};
    if (data.length === 0) {
      return grouped;
    }
    grouped = this.group(data, metricsKeys, grouped);
    var aggregated = this.lastOptGroupWeekData(grouped);
    return this.calcGap(aggregated.data);
  };
  return KpiRibbonAggregation;
};
AnalysisKpiRibbonAggregationFactory.$inject = ['AbstractRomKpiRibbonAggregationFactory'];
module.exports = AnalysisKpiRibbonAggregationFactory;